/**
 * /financeiro/contas-pagar — wrapper que renderiza ContasView em modo SAIDA.
 */
import React from "react";
import ContasView from "./ContasView";

export default function ContasAPagar() {
  return <ContasView tipo="SAIDA" />;
}
